import { Action } from '@ngrx/store';
import { Customers } from '../../_models/customers';
import { User } from '../../_models/user';

export enum CustomersActitonTypes {

  ClearCustomers = '[Customers] Clear',
  InicializeCustomers = '[Customers] Inicialize',

  GetCurrentCustomers = '[Customers] Get Current',
	SetCurrentCustomers = '[Customers] Set Current',
	SetCurrentCustomersId = '[Customers] Set Current Id',

	SetFilterFields = '[Customers] Set Filter Fields',

	LoadCustomerss = '[Customers] Get List',
	LoadCustomerssSuccess = '[Customers] Load Success',
  LoadCustomerssFail = '[Customers] Load Fail',

  UpdateCustomers = '[Customers] Update',
  UpdateCustomersSuccess = '[Customers] Update Success',
	UpdateCustomersFail = '[Customers] Update Fail',

	CreateCustomers = '[Customers] Create',
  CreateCustomersSuccess = '[Customers] Create Success',
	CreateCustomersFail = '[Customers] Create Fail',

	DeleteCustomers = '[Customers] Delete',
  DeleteCustomersSuccess = '[Customers] Delete Success',
	DeleteCustomersFail = '[Customers] Delete Fail',

	LoadUsers = '[Customers] Get Users',
	LoadUsersSuccess = '[Customers] Load Users Success',
  LoadUsersFail = '[Customers] Load Users Fail'
}

export class ClearCustomers implements Action {
	readonly type = CustomersActitonTypes.ClearCustomers;
}

export class InicializeCustomers implements Action {
	readonly type = CustomersActitonTypes.InicializeCustomers;
}

export class GetCurrentCustomers implements Action {
	readonly type = CustomersActitonTypes.GetCurrentCustomers;
}

export class SetCurrentCustomers implements Action {
	readonly type = CustomersActitonTypes.SetCurrentCustomers;

	constructor(public payload: Customers) {}
}

export class SetCurrentCustomersId implements Action {
	readonly type = CustomersActitonTypes.SetCurrentCustomersId;

	constructor(public payload: bigint) {}
}

export class SetFilterFields implements Action {
	readonly type = CustomersActitonTypes.SetFilterFields;

	constructor(public payload: any) {}
}

export class LoadCustomerss implements Action {
	readonly type = CustomersActitonTypes.LoadCustomerss;

	constructor(public payload: any) {}
	// constructor(public payload: {
    //   finished: boolean,
    //   searchDesc: string,
    //   searchName: string
    // }) {}
}

export class LoadCustomerssSuccess implements Action {
	readonly type = CustomersActitonTypes.LoadCustomerssSuccess;

	constructor(public payload: Customers[]) {}
}

export class LoadCustomerssFail implements Action {
	readonly type = CustomersActitonTypes.LoadCustomerssFail;

	constructor(public payload: string) {}
}

export class UpdateCustomers implements Action {
	readonly type = CustomersActitonTypes.UpdateCustomers;

	constructor(public payload: Customers) {}
}

export class UpdateCustomersSuccess implements Action {
	readonly type = CustomersActitonTypes.UpdateCustomersSuccess;

	constructor(public payload: Customers) {}
}

export class UpdateCustomersFail implements Action {
	readonly type = CustomersActitonTypes.UpdateCustomersFail;

	constructor(public payload: string) {}
}

export class DeleteCustomers implements Action {
	readonly type = CustomersActitonTypes.DeleteCustomers;

	constructor(public payload: Customers) {}
}

export class DeleteCustomersSuccess implements Action {
	readonly type = CustomersActitonTypes.DeleteCustomersSuccess;

	constructor(public payload: bigint) {}
}

export class DeleteCustomersFail implements Action {
	readonly type = CustomersActitonTypes.DeleteCustomersFail;

	constructor(public payload: string) {}
}

export class CreateCustomers implements Action {
	readonly type = CustomersActitonTypes.CreateCustomers;

	constructor(public payload: Customers) {}
}

export class CreateCustomersSuccess implements Action {
	readonly type = CustomersActitonTypes.CreateCustomersSuccess;

	constructor(public payload: Customers) {}
}

export class CreateCustomersFail implements Action {
	readonly type = CustomersActitonTypes.CreateCustomersFail;

	constructor(public payload: string) {}
}


// ------- AGENTES COMERCIALES --------
export class LoadUsers implements Action {
	readonly type = CustomersActitonTypes.LoadUsers;
}

export class LoadUsersSuccess implements Action {
	readonly type = CustomersActitonTypes.LoadUsersSuccess;

	constructor(public payload: User[]) {}
}

export class LoadUsersFail implements Action {
	readonly type = CustomersActitonTypes.LoadUsersFail;

	constructor(public payload: string) {}
}

// Unión de acciones
export type CustomersActions = ClearCustomers
| InicializeCustomers
| GetCurrentCustomers
| SetCurrentCustomers
| SetCurrentCustomersId
| SetFilterFields
| LoadCustomerss
| LoadCustomerssSuccess
| LoadCustomerssFail
| UpdateCustomers
| UpdateCustomersSuccess
| UpdateCustomersFail
| CreateCustomers
| CreateCustomersSuccess
| CreateCustomersFail
| DeleteCustomers
| DeleteCustomersSuccess
| DeleteCustomersFail
| LoadUsers
| LoadUsersSuccess
| LoadUsersFail;
